/** Guide status labels shared by `GuideProgress` and its consumers (#436). */

/** A member's status for one guide, as the guides API reports it. */
export type GuideStatus = "not_started" | "in_progress" | "done" | "dismissed" | "reopened";

export interface GuideStatusMeta {
  label: string;
  color: string;
}

const STATUS_META: Record<GuideStatus, GuideStatusMeta> = {
  not_started: { label: "Not started", color: "gray" },
  in_progress: { label: "In progress", color: "blue" },
  done: { label: "Finished", color: "teal" },
  dismissed: { label: "Skipped", color: "gray" },
  reopened: { label: "New steps", color: "orange" },
};

/** Label and badge colour for a guide status; unknown values read as not started. */
export function guideStatusMeta(status: string): GuideStatusMeta {
  return STATUS_META[status as GuideStatus] ?? STATUS_META.not_started;
}
